<app-spinner *ngIf="loading"></app-spinner>
<app-error-message *ngIf="loadingError" [errorMessage]="loadingError"></app-error-message>
<ng-container *ngIf="!loading && !loadingError">
  <div class="no-results" *ngIf="!nodes.data.length">There are no tasks for this project</div>

  <cdk-virtual-scroll-viewport *ngIf="nodes.data.length" class="virtual-scroll-container aker-dark-theme" itemSize="48">
    <ng-container *cdkVirtualFor="let node of nodes; trackBy: trackByFn">
      <div class="node">
        <ng-container [ngSwitch]="node.nodeType">
          <a
            *ngSwitchCase="nodeType.CP"
            [routerLink]="['cp', node.id]"
            [routerLinkActiveOptions]="{ exact: true }"
            routerLinkActive="active-node"
            class="cp-expand-node"
          >
            <span>
              <span [matTooltip]="node.name" [matTooltipPosition]="'right'" [matTooltipShowDelay]="200">
                <app-status-icon
                  *ngIf="displayStatusIcon()"
                  [status]="node.status"
                  [packageType]="node.nodeType"
                  [packageNumber]="node.number"
                ></app-status-icon>
                <span class="cp-node-content">
                  <span>{{ node.number }}</span>
                  <span
                    class="cp-certificate-bars"
                    *ngIf="node.nodeType === nodeType.CP"
                    role="button"
                    tabindex="0"
                    [matTooltip]="coverageTooltip(node.mccCoverage, node.rfccCoverage, node.rfocCoverage)"
                    [matTooltipPosition]="'right'"
                    (click)="openNonCertifiedAssignmentsDialog($event, node)"
                    (keyup.enter)="openNonCertifiedAssignmentsDialog($event, node)"
                  >
                    <span class="cp-certificate-bar">
                      <span
                        class="cp-certificate-bar__fill"
                        [style.height.%]="coverageToFillPercent(node.mccCoverage)"
                        [ngClass]="'cp-certificate-bar__fill--' + coverageState(node.mccCoverage)"
                      ></span>
                    </span>
                    <span class="cp-certificate-bar">
                      <span
                        class="cp-certificate-bar__fill"
                        [style.height.%]="coverageToFillPercent(node.rfccCoverage)"
                        [ngClass]="'cp-certificate-bar__fill--' + coverageState(node.rfccCoverage)"
                      ></span>
                    </span>
                    <span class="cp-certificate-bar">
                      <span
                        class="cp-certificate-bar__fill"
                        [style.height.%]="coverageToFillPercent(node.rfocCoverage)"
                        [ngClass]="'cp-certificate-bar__fill--' + coverageState(node.rfocCoverage)"
                      ></span>
                    </span>
                  </span>
                </span></span
              >
            </span>

            <a
              [attr.data-testid]="node.nodeType + '-' + node.number"
              *ngIf="node.nodeType === nodeType.CP && node.hasChildren"
              (click)="toggle(node)"
              (keyup.enter)="toggle(node)"
              [name]="node.number"
              tabindex="0"
            >
              <mat-icon>
                {{ treeControl.isExpanded(node) ? 'arrow_drop_up' : 'arrow_drop_down' }}
              </mat-icon>
            </a>
          </a>
          <a
            *ngSwitchCase="nodeType.MCP"
            [routerLink]="['cp', node.parentId, 'mcp', node.id]"
            routerLinkActive="active-node"
            class="node-link"
          >
            <div>
              <span
                style="padding-left: 40px; width: 100%"
                [attr.data-testid]="node.nodeType + '-' + node.number"
                [matTooltip]="node.name"
                [matTooltipPosition]="'right'"
                [matTooltipShowDelay]="200"
              >
                <app-status-icon
                  *ngIf="displayStatusIcon()"
                  [status]="node.status"
                  [packageType]="node.nodeType"
                  [packageNumber]="node.number"
                ></app-status-icon>
                {{ node.number }}
              </span>
            </div>
          </a>
          <button
            [attr.data-testid]="node.nodeType + '-' + node.number"
            class="system-node"
            *ngIf="node.nodeType === nodeType.SYSTEM"
            (click)="toggleAndGoToLink(node)"
            [name]="node.number"
          >
            <span *ngSwitchCase="nodeType.SYSTEM">
              <span [matTooltip]="node.name" [matTooltipPosition]="'right'" [matTooltipShowDelay]="200"> {{ node.number }}</span>
            </span>
            <mat-icon>
              {{ treeControl.isExpanded(node) ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
            </mat-icon>
          </button>
          <div *ngSwitchCase="nodeType.SUBSYSTEM" class="subsystem-node">
            <span [matTooltip]="node.name" [matTooltipPosition]="'right'" [matTooltipShowDelay]="200"> {{ node.number }}</span>
          </div>
        </ng-container>
      </div>
    </ng-container>
  </cdk-virtual-scroll-viewport>
</ng-container>
